(function () {
  if (window.mobileBottomNavLoaded) return;
  window.mobileBottomNavLoaded = true;

  const controllers = new Map();
  const wishlistKeys = ['wishlist', 'shopify-wishlist', 'wishlist-items', 'localWishlist'];

  function normalizePath(pathname) {
    const normalized = pathname.replace(/\/+$/, '');
    return normalized || '/';
  }

  function wishlistCountFromStorage() {
    for (const key of wishlistKeys) {
      const data = localStorage.getItem(key);
      if (!data) continue;

      try {
        const parsed = JSON.parse(data);
        if (Array.isArray(parsed)) return parsed.length;
        if (parsed && typeof parsed === 'object') return Object.keys(parsed).length;
      } catch (_error) {
        const items = data.split(',').filter((item) => item.trim());
        if (items.length) return items.length;
      }
    }

    return 0;
  }

  class MobileBottomNav {
    constructor(nav) {
      this.nav = nav;
      this.section = nav.closest('.shopify-section');
      this.status = this.section?.querySelector('.js-mobile-nav-status');
      this.cartObserver = null;
      this.menuObserver = null;
      this.boundStorage = this.onStorage.bind(this);
      this.boundWishlistUpdate = this.onWishlistUpdate.bind(this);

      this.setActiveItem();
      this.initializeMenuButton();
      this.initializeCartBadge();
      this.updateWishlistBadge(wishlistCountFromStorage(), false);

      window.addEventListener('storage', this.boundStorage);
      document.addEventListener('wishlist:updated', this.boundWishlistUpdate);
    }

    setActiveItem() {
      const currentPath = normalizePath(window.location.pathname);
      let bestMatch = null;
      let bestScore = -1;

      this.nav.querySelectorAll('a.mobile-bottom-nav__item').forEach((item) => {
        if (item.getAttribute('href')?.startsWith('#')) return;

        let url;
        try {
          url = new URL(item.href, window.location.origin);
        } catch (_error) {
          return;
        }

        if (url.origin !== window.location.origin) return;
        const itemPath = normalizePath(url.pathname);
        let score = itemPath === currentPath ? 1000 + itemPath.length : -1;

        if (score < 0 && item.dataset.mobileNavIcon === 'grid') {
          if (currentPath.startsWith('/collections/') || currentPath.startsWith('/products/')) score = 10;
        } else if (score < 0 && itemPath !== '/' && currentPath.startsWith(`${itemPath}/`)) {
          score = itemPath.length;
        }

        if (score > bestScore) {
          bestMatch = item;
          bestScore = score;
        }
      });

      if (bestMatch && bestScore >= 0) {
        bestMatch.classList.add('is-active');
        bestMatch.setAttribute('aria-current', 'page');
      }
    }

    initializeMenuButton() {
      const button = this.nav.querySelector('[data-mobile-nav-menu]');
      const drawerDetails = document.querySelector('#Details-menu-drawer-container');
      const drawerTrigger = drawerDetails?.querySelector(':scope > summary');
      if (!button || !drawerDetails || !drawerTrigger) return;

      this.boundMenuClick = () => drawerTrigger.click();
      button.addEventListener('click', this.boundMenuClick);

      const updateExpanded = () => button.setAttribute('aria-expanded', drawerDetails.hasAttribute('open') ? 'true' : 'false');
      updateExpanded();
      this.menuObserver = new MutationObserver(updateExpanded);
      this.menuObserver.observe(drawerDetails, { attributes: true, attributeFilter: ['open'] });
    }

    setBadge(type, count, announce) {
      const badge = this.nav.querySelector(`.js-mobile-nav-${type}-badge`);
      const item = this.nav.querySelector(`[data-mobile-nav-badge="${type}"]`);
      if (!badge || !item) return;

      const value = Math.max(0, Number.parseInt(count, 10) || 0);
      const previousValue = Number.parseInt(badge.textContent, 10) || 0;
      const label = item.dataset.mobileNavLabel || type;

      badge.textContent = value;
      badge.hidden = value === 0;
      item.setAttribute('aria-label', value > 0 ? `${label}, ${value} item${value === 1 ? '' : 's'}` : label);

      if (announce && value !== previousValue && this.status) {
        this.status.textContent = `${label} now has ${value} item${value === 1 ? '' : 's'}.`;
      }
    }

    initializeCartBadge() {
      const headerCart = document.querySelector('#cart-icon-bubble');
      if (!headerCart || !this.nav.querySelector('.js-mobile-nav-cart-badge')) return;

      const update = (announce = true) => {
        const countElement = headerCart.querySelector('.cart-count-bubble span[aria-hidden="true"]');
        this.setBadge('cart', countElement?.textContent.trim() || 0, announce);
      };

      update(false);
      this.cartObserver = new MutationObserver(() => update(true));
      this.cartObserver.observe(headerCart, { childList: true, subtree: true, characterData: true });
    }

    updateWishlistBadge(count, announce = true) {
      this.setBadge('wishlist', count, announce);
    }

    onStorage(event) {
      if (wishlistKeys.includes(event.key)) this.updateWishlistBadge(wishlistCountFromStorage());
    }

    onWishlistUpdate(event) {
      const suppliedCount = event.detail && Number.isFinite(Number(event.detail.count))
        ? Number(event.detail.count)
        : wishlistCountFromStorage();
      this.updateWishlistBadge(suppliedCount);
    }

    destroy() {
      this.cartObserver?.disconnect();
      this.menuObserver?.disconnect();
      this.nav.querySelector('[data-mobile-nav-menu]')?.removeEventListener('click', this.boundMenuClick);
      window.removeEventListener('storage', this.boundStorage);
      document.removeEventListener('wishlist:updated', this.boundWishlistUpdate);
      controllers.delete(this.nav);
    }
  }

  function initialize(root = document) {
    root.querySelectorAll('.mobile-bottom-nav').forEach((nav) => {
      if (!controllers.has(nav)) controllers.set(nav, new MobileBottomNav(nav));
    });
  }

  initialize();

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    controllers.forEach((controller, nav) => {
      if (event.target.contains(nav)) controller.destroy();
    });
  });
})();
